<template>
    <div class="page_hx_select flex-col">
        <div class="group_10 flex-row">
            <div class="group_11 flex-col">
                <div class="list_9 flex-row">
                    <div
                            class="image_div flex-col"
                            @mouseover="hoverIndexFun(index) "
                            @mouseleave="offhoverIndexFun"
                            @click="handleClick(index)"
                            :style="{background: getBackground(index),backgroundSize: 'cover',backgroundRepeat: 'no-repeat'}"
                            v-for="(item, index) in loopData0"
                            :key="`item-${item.id}`"
                    >
                        <div style="margin-top: 15px" class="text-wrapper">
                            <span class="text_16" :style="{ color: getColor(index,1) }" v-html="item.lanhutext0"></span>
                            <span class="text_17" :style="{ color: getColor(index,2) }" v-html="item.lanhutext1"></span>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            selectedIndex: {
                type: Number,
                required: true,
                default: -1
            }
        },

        data() {
            return {
                currentSelect: this.selectedIndex,
                defaultSelect:-1,
                hoverIndex: -1,
                selectImgBj:require('../../../assets/advisory/advisory_select_type_m.png'),
                loopData0: [
                    {
                        id:'001',
                        lanhutext0: '渠道风控管理',
                        lanhufontColor0: 'rgba(37,37,37,1.000000)',
                        lanhutext1: 'Channel',
                        lanhufontColor1: 'rgba(153,153,153,1)'
                    },
                    {
                        id:'002',
                        lanhutext0: '业务合规管理',
                        lanhufontColor0: 'rgba(37,37,37,1.000000)',
                        lanhutext1: 'Compliance',
                        lanhufontColor1: 'rgba(153,153,153,1)'
                    },
                    {
                        id:'003',
                        lanhutext0: '企业健康咨询',
                        lanhufontColor0: 'rgba(37,37,37,1.000000)',
                        lanhutext1: 'Consultation',
                        lanhufontColor1: 'rgba(153,153,153,1)'
                    }
                ],
            };
        },

        methods: {
            getBackground(index){
                if (this.currentSelect === index) {
                    return `url(${this.selectImgBj})  center/cover no-repeat`;
                }
                if (this.hoverIndex === index) {
                    return 'rgba(0, 120, 126, 0.1)';
                }
                return 'rgba(247,247,247,1)';
            },
            getColor(index,type){
                if (this.currentSelect === index) {
                    return 'rgba(255,255,255,1)';
                }
                if (this.hoverIndex === index) {
                    if(type ===1){
                        return 'rgba(0, 120, 126, 1)';
                    }else{
                        return 'rgba(153,153,153,1)';
                    }
                }
                if(type === 2){
                    return 'rgba(153,153,153,1)';
                }
                if(type === 1){
                    return 'rgba(37, 37, 37, 1)';
                }
                return 'rgba(153,153,153,1)';
            },
            handleClick(index) {
                this.hoverIndex = -1;
                this.$emit('change', index); // 触发 change 事件
            },
            hoverIndexFun(index){
                this.hoverIndex = index;
                //this.currentSelect = index;
            },
            offhoverIndexFun(){
                //this.currentSelect = this.selectedIndex ;
                this.hoverIndex = -1;
            },
        }
    };
</script>
<style scoped lang="css"  >
    .page_hx_select {
        background-color: rgba(255, 255, 255, 1);
        position: relative;
        width: 100%;
        overflow: hidden;
    }

    .group_10 {
        width: 100%;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .group_11 {
        width: 100%;
        display: flex;
        justify-content: center;
    }

    .list_9 {
        width: 100%;
        max-width: 700px;
        justify-content: space-between;
        margin: 30px 15px 0 15px;
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }

    .image_div {
        width: 30%;
        max-width: 219px;
        height: 102px;
        cursor:pointer;
        will-change: background;

        transition: none;
        background-size: contain; /* 确保背景图缩放 */
        background-position: center; /* 确保背景图居中 */
        background-repeat: no-repeat; /* 防止重复 */
    }
    .flex-row {
        display: flex;
        flex-direction: row;
    }
    .text-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center; /* 子元素水平居中 */
    }
    .text_16 {
        max-width: 144px;
        height: 33px;
        overflow-wrap: break-word;
        font-size: 24px;
        font-family: AlibabaPuHuiTi_3_75_SemiBold;
        color: #252525;
        font-style: normal;
        font-weight: 600;
        text-align: center;
        white-space: nowrap;
        line-height: 33px;
    }

    .text_17 {
        max-width: 130px;
        height: 22px;
        opacity: 0.46;
        overflow-wrap: break-word;
        font-size: 22px;
        font-weight: 600;
        white-space: nowrap;
        line-height: 22px;
        margin: 0px 0 0 0;
        text-align: center;

    }

    @media (min-width: 481px) and (max-width: 700px) {
        .image_div {
            height: 75px;
        }
        .text_16 {
            font-size: 13px;
            height: 20px;
            line-height: 13px;
        }

        .text_17 {
            font-size: 12px;
            height: 12px;
            line-height: 10px;
        }
    }
    /* 超小屏幕样式 */
    @media (max-width: 480px) {
        .image_div {
            height: 64px;
        }
        .text_16 {
            font-size: 13px;
            height: 20px;
            line-height: 13px;
        }

        .text_17 {
            font-size: 12px;
            height: 12px;
            line-height: 6px;
        }
    }
    @media (max-width: 390px) {
        .image_div {
            height: 64px;
        }
        .text_16 {
            font-size: 13px;
            height: 18px;
            line-height: 13px;
        }

        .text_17 {
            font-size: 12px;
            height: 12px;
            line-height: 12px;
        }
    }


</style>
